import { snakeStore } from '@app/plugins/vuex-async-pagginate';
import { TaskService } from '@autoinformer/services/TaskService';
import { SORT_COLUMN, SORT_DIRECTION } from '@app/plugins/vuex-async-pagginate';


export const table = snakeStore(
  {
    state: {
      [SORT_COLUMN]: 'created_at',
      [SORT_DIRECTION]: 'desc'
    },
    actions: {
      getData: ({ rootState }, params) => {
        const id = rootState.autoinformer.campaigns.tasks.campaign_id;
        return TaskService.getList(id, params);
      }
    }
  },
  true
);
